// Reports.js
import React from 'react';
import ReportGenerator from './ReportGenerator';

const Reports = () => {
    return (
        <div>
            <h2>Reports</h2>
            <ReportGenerator />
        </div>
    );
};

export default Reports;
